"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ expand, setExpand, }) {
    return ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: e => {
            e.preventDefault();
            setExpand(!expand);
        }, sx: {
            p: 0,
            borderRadius: '6px',
            border: '1px solid var(--gray-10)',
            svg: {
                transform: `rotate(${expand ? 180 : 0}deg)`,
            },
        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { width: '18px', height: '18px' } }) })));
}
exports.default = default_1;
